import React, { useState } from "react";
import { Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Alignment, Href, WarningTop } from "../../../../Constant";
import { ALIGNMENT_DATA, ALIGNMENT_LIST } from "../../../../Data/UiKit/Dropdown";
import CommonDropDown from "../Common/CommonDropDown";

const Alignments = () => {
    const [open, setOpen] = useState(false);
    const toggle = () => setOpen(!open);
    return (
      <Col lg="6">
        <Card>
          <CommonCardHeader title={Alignment} span={ALIGNMENT_DATA} />
          <CardBody className="dropdown-basic m-0">
            <div className="common-flex">
              <div className="btn-group">
                <Dropdown isOpen={open} toggle={toggle} direction="up">
                  <DropdownToggle caret color="warning" className="text-white">{WarningTop}</DropdownToggle>
                  <DropdownMenu className="dropdown-block">
                    <DropdownItem href={Href}>Be careful </DropdownItem>
                    <DropdownItem href={Href}>Notifications</DropdownItem>
                    <DropdownItem href={Href}>Beware</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
              {ALIGNMENT_LIST.map((data, index) => (
                <CommonDropDown item={data} key={index}/>
              ))}
            </div>
          </CardBody>
        </Card>
      </Col>
    );
};

export default Alignments;
